/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Chip } from 'uikit/chips';
import { TextInput } from 'uikit/inputs';
import { Button } from 'uikit/buttons';

import styles from '../styles/formFieldChips.module.scss';

const FormFieldChips = ({
  chips = [],
  fieldId,
  handleAddChipsButtonClick = null,
  handleInputKeyDown = null,
  handleRemoveChip = null,
  handleUpdateTextInputValue = null,
  schema = { isDisabled: false },
  textInputValue = '',
}) => (
  <div>
    <div className={styles.inputContainer}>
      <TextInput
        id={fieldId}
        value={textInputValue}
        className={styles.input}
        onChange={handleUpdateTextInputValue}
        disabled={schema.isDisabled}
        onKeyDown={(event) => { handleInputKeyDown(event); }}
      />
      <Button
        text={i18n.t('add')}
        size="small"
        onClick={(event) => { handleAddChipsButtonClick(event); }}
        className={styles.button}
        color="primary"
        isDisabled={!textInputValue.length}
      />
    </div>
    {Boolean(chips.length) && (
      <ul className={styles.chips}>
        {chips.map((item, index) => (
          <Chip
            key={`chip-${index}`}
            text={item}
            onClick={() => { handleRemoveChip(index); }}
          />
        ))}
      </ul>
    )}
  </div>
);

FormFieldChips.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.string),
  textInputValue: PropTypes.string,
  schema: PropTypes.shape({
    isDisabled: PropTypes.bool,
  }),
  fieldId: PropTypes.string.isRequired,
  handleRemoveChip: PropTypes.func,
  handleInputKeyDown: PropTypes.func,
  handleAddChipsButtonClick: PropTypes.func,
  handleUpdateTextInputValue: PropTypes.func,
};

export default FormFieldChips;
